<script setup>
defineProps({
  color: {
    type: String,
    default: 'rgb(29, 29, 29)',
  },
  width: {
    type: String,
    default: '1.8rem',
  },
})
</script>

<template>
  <span class="loading-overlay__spinner">
    <svg
        :style="`width: ${width}!important;`"
        aria-hidden="true"
        focusable="false"
        role="presentation"
        class="spinner"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
    >
      <circle
          class="path"
          fill="none"
          stroke-width="6"
          :stroke="color"
          cx="33"
          cy="33"
          r="30"
      ></circle>
    </svg>
  </span>
</template>

<style lang="scss" scoped>
.loading-overlay__spinner {
  display: inline-block!important;

  .spinner {
    animation: rotator 1.4s linear infinite;

    circle {
      stroke-dasharray: 280;
      stroke-dashoffset: 0;
      transform-origin: center;
      animation: dash 1.4s ease-in-out infinite;
    }
  }
}
</style>
